export const ERROR_MESSAGES: { [key: string]: string } = {
  ERR_GENERIC: "Ha ocurrido un error. Por favor, inténtelo de nuevo.",
  ERR_AUTH_LOGIN_USER_NOT_FOUND: "Usuario no encontrado.",
};
